import { getMask } from './get-mask';

export const getDateMask = getMask(() => (str) => {
  const regexp = /\d/;
  const isTextBlack = regexp.test(str);

  return { str, isTextBlack };
});
